import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../../../core/consts";
import {GameCenterWidgetState} from "../models/game-center-widget.state";

export class GameCenterWidgetLivePenaltiesPopupClickHandler extends ActionHandler {
  state: GameCenterWidgetState;
  type = ACTION_TYPES.onLivePenaltiesPopupClick;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.shouldRenderLivePenaltiesPopup = params.isVisible;
    if(!params.isVisible) {
      this.state.forceHideLivePenaltyPopup = true;
    }
  }
}
